const {
  combForSource,
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate ifAnyBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const values = await evaluateSource(source.values, content, parentContentPath, transientContext, nativeFunctions);
  if (values === undefined || !Array.isArray(values)) {
    return undefined;
  }
  const comb = await combForSource(source, content, parentContentPath, transientContext, nativeFunctions);
  return values.length > 0 && values.some(comb);
};
module.exports = {
  evaluate
};